export default __webpack_public_path__ + "static/media/affan.08945908.webp";